export var INIT_COORDS = 'dnd-core/INIT_COORDS';
export var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
export var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
export var HOVER = 'dnd-core/HOVER';
export var DROP = 'dnd-core/DROP';
export var END_DRAG = 'dnd-core/END_DRAG';


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/actions/dragDrop/types.js
// module id = 69
// module chunks = 4